import React from "react";
import {
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
} from "@mui/material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import { Search } from "../../UI/Search/Search";
import { CompanyFilterDropdown } from "./CompanyFilterDropdown";
import { PromotionHistoryDateFilter } from "./PromotionHistoryDateFilter";
import {
  DEFAULT_PROMOTIONS_DATE_FILTER_FIELD,
  PROMOTIONS_DATE_FILTER_OPTIONS,
} from "./promotionHistoryColumns";
import { PROMOTIONS_LIST_MODES } from "./promotionListModes";

export const PromotionsEligibilityFilters = ({
  mode = PROMOTIONS_LIST_MODES.REPORT,
  searchInput,
  onSearchChange,
  dateField,
  dateStart,
  dateEnd,
  onDateApply,
  onDateReset,
  companies = [],
  companyIds = [],
  onCompanyIdsApply,
  status = "",
  statuses = [],
  onStatusChange,
  onExport,
  isExporting = false,
  exportDisabled = false,
  toolbarEnd = null,
}) => {
  const showStatusFilter = mode === PROMOTIONS_LIST_MODES.REPORT;
  const showExport = typeof onExport === "function";

  return (
    <div className="promotions-page__toolbar">
      <div className="promotions-page__search">
        <Search
          placehold="Search.."
          searchVal={searchInput}
          setSearchVal={onSearchChange}
        />
      </div>
      <div className="promotions-page__filters">
        <PromotionHistoryDateFilter
          field={dateField}
          startDate={dateStart}
          endDate={dateEnd}
          options={PROMOTIONS_DATE_FILTER_OPTIONS}
          defaultField={DEFAULT_PROMOTIONS_DATE_FILTER_FIELD}
          onApply={onDateApply}
          onReset={onDateReset}
        />
        <CompanyFilterDropdown
          companies={companies}
          appliedIds={companyIds}
          onApply={onCompanyIdsApply}
          variant="toolbar"
        />
        {showStatusFilter ? (
          <FormControl className="promotions-page__select">
            <Select
              displayEmpty
              value={status}
              IconComponent={ArrowForwardIosIcon}
              onChange={(e) => onStatusChange?.(e.target.value)}
              renderValue={(selected) => {
                if (!selected) return "Status";
                const match = statuses.find((s) => s.value === selected);
                return match?.label || "Status";
              }}
              endAdornment={
                status ? (
                  <InputAdornment
                    position="end"
                    className="promotions-page__select-clear"
                  >
                    <IconButton
                      size="small"
                      aria-label="Clear status"
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={(e) => {
                        e.stopPropagation();
                        onStatusChange?.("");
                      }}
                    >
                      <ClearOutlinedIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ) : null
              }
            >
              {statuses.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : null}
        {showExport ? (
          <Button
            variant="contained"
            className="promotions-page__export"
            startIcon={<FileUploadOutlinedIcon />}
            onClick={onExport}
            disabled={exportDisabled || isExporting}
          >
            {isExporting ? "Exporting…" : "Export"}
          </Button>
        ) : null}
        {toolbarEnd}
      </div>
    </div>
  );
};
